import type { Descendant } from 'platejs'

/** API-wide markdown field limit (profile bio, org about, job description). */
export const MARKDOWN_FIELD_MAX_LENGTH = 5000

/** Plate markdown serialize uses U+200B in empty blocks — not user-visible content. */
const MARKDOWN_FIELD_ZWSP = '\u200B'

/** remark-stringify encodes line-adjacent spaces as numeric entities — decode for editing. */
const MARKDOWN_SPACE_ENTITY_PATTERN = /&#x20;|&#32;/gi

/**
 * Decode remark-stringify HTML character references for spaces so Markdown mode
 * shows literal spaces instead of `&#x20;`.
 */
export function humanizeRichTextMarkdown(markdown: string): string {
  return markdown.replace(MARKDOWN_SPACE_ENTITY_PATTERN, ' ')
}

/** Visible text count from a Plate document — canonical preview semantics. */
export function plateDocumentCharCount(nodes: Descendant[]): number {
  let count = 0

  const walk = (node: Descendant) => {
    if ('text' in node && typeof node.text === 'string') {
      const text = node.text.split(MARKDOWN_FIELD_ZWSP).join('')
      // Ignore Plate padding on blank lines, but count user-typed spaces (incl. trailing).
      if (text.trim() === '') return
      count += text.length
    }
    if ('children' in node && Array.isArray(node.children)) {
      node.children.forEach(walk)
    }
  }

  nodes.forEach(walk)
  return count
}

